export default import.meta.ROLLDOWN_FILE_URL_LvOJhKd7oX2Gi43xkSh4$Q